import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// Moment
Vue.use(require('vue-moment'))

// Get user defined feed settings
const feedSettings = window.gappInlineSettings

const keys = Object.keys(feedSettings)

// Loop through locations
for (let i = 0; i < keys.length; i++) {
  let key = keys[i]

  // Create target element
  let targetElem = document.createElement('div')
  targetElem.className = `gapp-post-feed__container--${feedSettings[key].location}`

  // Get initial target container
  const contentContainerSelector = feedSettings[key].container
  let contentContainer = document.querySelector(contentContainerSelector)

  // Select nth sibling if container offset is greater than 0
  let sibling = null
  if (parseInt(feedSettings[key].container_offset) > 0) {
    let i = 0
    while (i < parseInt(feedSettings[key].container_offset)) {
      if (i === 0) {
        sibling = contentContainer.nextElementSibling
      } else {
        sibling = sibling.nextElementSibling
      }
      i++
    }
  }

  // change content container if sibling exists
  if (sibling) {
    contentContainer = sibling
  }

  let referenceElem = null

  // Select midpoint if feed location is middle
  if (feedSettings[key].location === 'middle') {
    // all p elements
    const paragraphs = contentContainer.getElementsByTagName('p')

    // Get the middle p elem
    let k = 0
    const mid = Math.floor(paragraphs.length / 2)
    while (paragraphs[mid + k].parentNode.nodeName.toLowerCase() === 'blockquote') {
      k++
    }
    const targetParagraph = paragraphs[Math.floor(paragraphs.length / 2 + k)]

    // target parent elem
    contentContainer = targetParagraph

    // Define reference elem
    referenceElem = targetParagraph.nextSiblingElem
  } else if (feedSettings[key].container_offset_target) {
    let selector = feedSettings[key].container_offset_target
    let subContainer
    if (selector.charAt(0) === '.') {
      selector = selector.replace('.', '')
      subContainer = contentContainer.getElementsByClassName(selector)
      subContainer = subContainer[0]
    } else if (selector.charAt(0) === '#') {
      selector = selector.replace('#', '')
      subContainer = document.getElementById(selector)
    }

    contentContainer = subContainer
  }

  contentContainer.insertBefore(targetElem, referenceElem)

  // Create new Vue instance for feed
  new Vue({
    render: h => h(App, {
      props: {
        feedSettings: feedSettings[key]
      }
    })
  }).$mount(`.gapp-post-feed__container--${feedSettings[key].location}`)
}
